import React, { Suspense, lazy, memo } from 'react';
import { canUseDOM } from '../../utils';
var CampaignScriptGeneratorLazyLoadedContent = /*#__PURE__*/lazy(function () {
  return import("./CampaignScriptGeneratorLazyLoadedContent");
});
var SuspenseWrapper = function SuspenseWrapper(props) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(CampaignScriptGeneratorLazyLoadedContent, props));
};
var CampaignScriptGenerator = function CampaignScriptGenerator(props) {
  return canUseDOM ? /*#__PURE__*/React.createElement(SuspenseWrapper, props) : null;
};
export default /*#__PURE__*/memo(CampaignScriptGenerator);